import { api } from './client';

export const athletesAPI = {
  acknowledgeVolumeWarning: (acknowledged) => api.patch('/athletes/me/acknowledge-volume-warning/', { acknowledged }),
  list: (params) => api.get('/athletes/', { params }),
  getTelegramLinkToken: () => api.post('/athletes/telegram-link-token/'),
  changePassword: (currentPassword, newPassword) =>
    api.post('/athletes/me/change-password/', { current_password: currentPassword, new_password: newPassword }),
  get: (id) => api.get(`/athletes/${id}/`),
  me: () => api.get('/athletes/me/'),
  update: (id, data) => api.patch(`/athletes/${id}/`, data),
  updateMe: (data) => api.patch('/athletes/me/update/', data),
  delete: (id) => api.delete(`/athletes/${id}/`),
  stats: (id) => api.get(`/athletes/${id}/stats/`),
  vdotHistory: (id) => api.get(`/athletes/${id}/vdot-history/`),
  adminList: () => api.get('/athletes/admin/list/'),
  adminUpdate: (id, data) => api.patch(`/athletes/${id}/admin/update/`, data),
  toggleAccess: (id) => api.patch(`/athletes/${id}/admin/toggle-access/`),
  setAccess: (id, days) => api.patch(`/athletes/${id}/admin/set-access/`, { days }),
  addWeight: (id, weight) => api.post(`/athletes/${id}/add-weight/`, { weight }),
  disconnectTelegram: () => api.post('/athletes/telegram-disconnect/'),
  addHrMaxObservation: (id, observed_max_hr) => api.post(`/athletes/${id}/add-hr-max-observation/`, { observed_max_hr }),
  addHrMaxEstimate: (id, race_distance_m, hr_avg_last_1km) =>
    api.post(`/athletes/${id}/add-hr-max-estimate/`, { race_distance_m, hr_avg_last_1km }),
};